import React, { Component } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import { requestUser, getUser } from '../../ducks/admin/users'
import EmptyState from '../Shared/EmptyState'
import Loading from '../Shared/Loading'
import Page from '../Shared/Page'
import AppIcon from '../Shared/AppIcon'

import './Admin.scss'

class AppItem extends Component {
  render() {
    const { app } = this.props

    return (
      <Link className="admin-user-item" to={`/apps/${app.id}`}>
        <AppIcon app={app} />
        <h5>{app.name}</h5>
        <p>{app.createdAt}</p>
        <p>{app.updatedAt}</p>
      </Link>
    )
  }
}

export class AdminUserOrganization extends Component {
  getStatus = () => {
    const { organization } = this.props

    if (organization.active) {
      return 'paying'
    } else {
      return 'free'
    }
  }

  render() {
    const { organization } = this.props
    const orgStatus = this.getStatus()

    return (
      <span className="admin-user-organization">
        <span className="admin-user-org-sub">
          {organization.name}
          <span
            className={classNames('admin-org-status', `admin-org-${orgStatus}`)}
          >
            {orgStatus}
          </span>
        </span>
      </span>
    )
  }
}

class AdminApps extends Component {
  componentDidMount() {
    const { match, requestUser } = this.props

    requestUser(match.params.userId)
  }

  render() {
    const { user } = this.props

    if (!user) {
      return (
        <EmptyState greedy>
          <Loading large />
        </EmptyState>
      )
    }

    const apps = user.Apps

    return (
      <Page className="admin-users-page" title="Users">
        <Link to="/admin/users">Back to Users</Link>
        <h1>{user.name}</h1>
        <h2>{user.email}</h2>
        <h3>
          {user.Organizations.map(org => (
            <AdminUserOrganization key={org.id} organization={org} />
          ))}
        </h3>
        <div>
          {apps.map(app => (
            <AppItem key={app.id} app={app} />
          ))}
        </div>
      </Page>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  user: getUser(state, match.params.userId),
})

export default connect(mapStateToProps, { requestUser })(AdminApps)
